// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const UserConfiguration = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
    >
      <circle cx="13.9" cy="14.2" r="6.3" />
      <path d="M2.5,26.6c0,4.9,4.9,10.9,10.9,10.9s4.1-.8,5.7-1.9c-2.1-2.5-3.3-5.6-3.3-8.4s1.9-2.3,4.6-2.8c-6.2-1.3-17.9-.6-17.9,2.3Z" />
      <circle cx="30.1" cy="11.6" r="8.1" />
      <path d="M43.1,28.5c0-.5,0-1,0-1.4,0-2-4.6-3.2-10.1-3.6-4.4-.3-9.3,0-12.7.8-2.8.6-4.6,1.5-4.6,2.8,0,2.8,1.2,6,3.3,8.4,2.3,2.8,5.5,4.8,9.2,5.2h0" />
      <path d="M45.8,38.3c-.6,0-1-.6-1-1v-1.4h0s0,0,0,0c0-.5.4-1,1-1l1.2-.3c-.3-1.2-.8-2.4-1.4-3.4l-.9.7c-.5.4-1,.4-1.4,0l-1-1c-.3-.4-.3-1,0-1.4l.7-1c-.9-.7-2.1-1.1-3.3-1.4l-.2,1.1c0,.6-.6,1-1,1h-1.4c-.5,0-1-.4-1-1l-.3-1.2c-1.2.3-2.4.8-3.4,1.4l.8,1c.4.5.4,1,0,1.4l-1,1c-.3.4-1,.4-1.4,0l-1-.8c-.7,1-1.1,2.2-1.4,3.4l1.3.3c.6.2,1,.6,1,1v1.4c0,.5-.5,1-1,1l-1.2.2c.3,1.2.8,2.4,1.4,3.4l1-.8c.5-.4,1-.3,1.4,0l1,1c.4.3.4,1,0,1.4l-.8,1c1,.7,2.2,1.1,3.4,1.4l.3-1.2c0-.6.6-1,1-1h1.4c.5,0,1,.5,1,1l.2,1.2c1.2-.3,2.4-.8,3.3-1.4l-.7-1c-.4-.5-.4-1,0-1.4l1-1c.4-.3,1-.3,1.4,0l1,.7c.7-.9,1.1-2.1,1.4-3.3l-1.1-.2ZM37.5,39c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5,2.5,1.1,2.5,2.5-1.1,2.5-2.5,2.5Z" />
    </svg>
  );
};
